import { Button, Modal } from 'flowbite-react'

interface CancelarPedidoModalProps {
  isOpen: boolean | false
  onClose: any
  onConfirm: () => void
}

export default function CancelarPedidoModal({
  isOpen,
  onClose,
  onConfirm
}: CancelarPedidoModalProps) {
  return (
    <Modal show={isOpen} size={'sm'} onClose={onClose} popup>
      <Modal.Header />
      <Modal.Body>
        <div className='text-center'>
          <h3 className='mb-5 text-lg font-normal text-gray-500'>
            Os pedidos serão cancelados, deseja continuar?
          </h3>
          <h3 className='mb-5 text-sm font-normal text-gray-500'>
            *Esta ação não poderá ser desfeita
          </h3>
          <div className='flex justify-center gap-4'>
            <Button color='gray' onClick={onClose} data-testid='btn-close'>
              Não
            </Button>
            <Button
              color='success'
              onClick={onConfirm}
              data-testid='btn-confirm'
            >
              Sim
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}
